import { render, staticRenderFns } from "./ConfirmMoveCallModal.vue?vue&type=template&id=3bc972f0&scoped=true"
import script from "./ConfirmMoveCallModal.vue?vue&type=script&lang=js"
export * from "./ConfirmMoveCallModal.vue?vue&type=script&lang=js"
import style0 from "./ConfirmMoveCallModal.vue?vue&type=style&index=0&id=3bc972f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc972f0",
  null
  
)

export default component.exports